import React from "react";
import CoverLines from "../../../../assets/images/CT/CoverLines.png";
const CoverUp = ({ active_player_details, coverUp }) => {
  return (
    <>
      <div className="ct-cover-up-screen">
        <div className="cover-up-content">
          <div className="cover-top-text">
            <h3>
              Briefly, a bird flew by the window in question, but unbenownst to
              the statesman being questioned the real cover of darkness unknown
              is up to something truth gone out to pasture
            </h3>
            <img src={CoverLines} alt="" />
          </div>
        </div>
        <div className="cover-down-content">
          <div className="content">
            <p>
              “You start feeling a buzzing in your head and realize you forgot
              to wear your tin foil, mind-control-signal -blocking hat. Your
              head starts to spin. After a second, your mind clears and you
              understand exactly what you need to do. You walk over to your
              computer, delete all of your conspiracy files then sit down to
              watch reality TV.”
            </p>
            <h4>
              {active_player_details?.display_name}{" "}
              <span>{coverUp?.instructions}</span>
            </h4>
          </div>
        </div>
      </div>
    </>
  );
};

export default CoverUp;
